import clsx from "clsx";

import { useTheme } from "@voxmedia/duet-framework/components/app/ThemeProvider";
import { coralOverrideClass } from "@voxmedia/duet-ui/shared-styles/coral-token-connect.css";
import vergeDark from "@voxmedia/duet-ui/themes/theverge-dark.css";
import { coralThemeOverrides } from "src/styles/coral-theme.css";

/** Whether the active page theme is a Verge dark variant (`vergeDark` or `?theme=dark`). */
export function isVergeDarkThemeKey(themeKey: string | undefined): boolean {
  return themeKey === "vergeDark" || themeKey === "dark";
}

/**
 * Class list for Coral drawer + embed host. Matches network posts, plus `vergeDark`
 * on the embed host in dark mode so palette tokens resolve inside Coral's shadow tree.
 * Do not pin `vergeLight` here — that forced full light mode even when the page was dark.
 */
export function useCskCoralSurfaceClassName(): string {
  const themeCtx = useTheme();
  const darkSurface = isVergeDarkThemeKey(themeCtx?.resolvedTheme) && vergeDark;

  return clsx(coralOverrideClass, coralThemeOverrides, darkSurface);
}

/** Remount Coral when the page theme changes so the embed picks up new CSS variables. */
export function useCskCoralEmbedKey(storyId: string): string {
  const themeCtx = useTheme();
  const themeKey = themeCtx?.resolvedTheme;
  const mode = isVergeDarkThemeKey(themeKey) ? "dark" : "light";
  return `${storyId}:${mode}`;
}
